import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';

import {AuthService} from './auth.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NotificationToastContainerComponent } from './notification-toast-container/notification-toast-container.component';
import { LoginComponent } from './login/login.component';
import { AsyncPipe, NgClass } from '@angular/common';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterLink, NgClass, RouterLinkActive, LoginComponent, RouterOutlet, NotificationToastContainerComponent, AsyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

    isCollapsed = true;
    user$: Observable<string | null>;

    loading = true;


    constructor(public authService: AuthService, private router: Router, private cdr: ChangeDetectorRef) {
        router.events.subscribe((event: Event) => {
            this.navigationInterceptor(event);
        });
    }


    ngOnInit() {
        this.user$ = this.authService.user$;
    }

    private navigationInterceptor(event: Event) {
        if (event instanceof NavigationStart) {
            this.loading = true;
            this.cdr.markForCheck();
            return;
        }
        if (event instanceof NavigationEnd) {
            this.loading = false;
            this.cdr.markForCheck();
            return;
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.loading = false;
            this.cdr.markForCheck();
            return;
        }
        if (event instanceof NavigationError) {
            this.loading = false;
            this.cdr.markForCheck();
        }
    }

}
